<template>
  <el-dialog
    title="添加人员"
    :visible.sync="addVisible"
    append-to-body
    width="60%"
    style="margin-top: -10vh;"
    @close="$emit('close')"
  >
    <el-col :span="10">
      <el-input class="search-input" placeholder="搜索姓名" v-model="name">
        <i
          slot="suffix"
          class="el-input__icon el-icon-search"
          @click="handleSearch"
          style="cursor: pointer"
        ></i>
      </el-input>
    </el-col>
    <el-table
      :data="investigationPerson && investigationPerson.results"
      ref="table"
      border
      :row-key="getRowKeys"
      v-loading="loading"
      @selection-change="saveSelection"
      fit
      height="400px"
      style="width: 100%"
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        align="center"
        width="44"
      >
      </el-table-column>
      <el-table-column prop="name" label="姓名" align="center">
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="companyName"
        align="center"
        label="公司"
      >
      </el-table-column>
      <el-table-column prop="cluesSourceName" align="center" label="来源">
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="intention"
        align="center"
        label="意向"
      >
      </el-table-column>
      <el-table-column align="center" width="200px" label="状态">
        <template slot-scope="{ row }">
          {{ row.cluesStatus | statusFilter }}
        </template>
      </el-table-column>
      <el-table-column prop="salesmanName" align="center" label="业务员">
      </el-table-column>
    </el-table>
    <!-- 客户列表分页 -->
    <div class="pageination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagenation.pageNumber"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pagenation.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="(investigationPerson && investigationPerson.totalCount) || 0"
      >
      </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <crm-button :buttonType="'plain'" :text="'取消'" @click="$emit('close')">
      </crm-button>
      <crm-button :text="'确定'" @click="handleSaveInvPersonAdd()"></crm-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CrmButton from '@/components/base/crmButton';

export default {
  props: {
    visible: Boolean,
  },
  components: {
    CrmButton,
  },
  filters: {
    statusFilter(val) {
      let result = null;
      if (val === 0) result = '待处理';
      if (val === 1) result = '跟进中';
      if (val === 2) result = '已转换';
      if (val === 3) result = '失效';
      if (val === 4) result = '其他';
      return result;
    },
  },
  data() {
    return {
      loading: false,
      addVisible: false,
      name: null,
      pagenation: {
        pageNumber: 1,
        pageSize: 10,
      },
      inspectPersonnel: [],
    };
  },
  computed: {
    ...mapGetters({
      investigationPerson: 'customer/investigationPerson',
    }),
  },
  watch: {
    visible(val) {
      this.addVisible = val;
      if (val) this.handleSearch();
    },
  },
  methods: {
    ...mapActions({
      getInvestigationPerson: 'customer/getInvestigationPerson',
    }),
    handleSearch() {
      this.pagenation.pageNumber = 1;
      this.handleGetInvestigationPerson();
    },
    handleGetInvestigationPerson() {
      this.loading = true;
      return this.getInvestigationPerson({
        name: this.name,
        ...this.pagenation,
      }).finally(() => {
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      this.pagenation.pageSize = val;
      this.pagenation.pageNumber = 1;
      this.handleGetInvestigationPerson();
    },
    handleCurrentChange(val) {
      this.pagenation.pageNumber = val;
      this.handleGetInvestigationPerson();
    },
    getRowKeys(row) {
      return row.id;
    },
    // 保存表格多选数据
    saveSelection(selection) {
      this.inspectPersonnel = selection;
    },
    handleSaveInvPersonAdd() {
      const list = [];
      this.inspectPersonnel.forEach((item) => {
        list.push({
          isLeader: false,
          cluesName: item.name,
          cluesCompany: item.companyName,
          cluesId: item.id,
        });
      });
      this.$emit('close');
      this.$emit('save', list);
      this.$refs.table.clearSelection();
    },
  },
};
</script>

<style></style>
